/* eslint-disable react-hooks/rules-of-hooks */
import { UseMutationResult, useMutation } from '@tanstack/react-query';

import * as GptApi from './GPT/GptApi';
import { StreamCompletionParams } from './GPT/GptApi';

export const streamChatCompletion = <T>(
  onSuccess,
): UseMutationResult<unknown, unknown, StreamCompletionParams<T>> => {
  return useMutation((params) => GptApi.streamChatCompletion(params), {
    onSuccess,
  });
};
